
import { defineComponent } from 'vue'
import ALoader from '@/components/ALoader.vue'
import FollowersList from '@/components/Profile/FollowersList.vue'
import { useProfileShow } from '@/composables/user/user'
import AIcon from '@/components/AIcon.vue'

export default defineComponent({
  name: 'FollowersPostList',
  components: { AIcon, FollowersList, ALoader },
  setup() {
    return {
      ...useProfileShow(),
    }
  },
})
